export const formatHeat = (value: number): string => {
  if (value >= 10000000) return `${(value / 10000000).toFixed(1)}千万`;
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  if (value >= 1000) return `${(value / 1000).toFixed(1)}千`;
  return String(value);
};

export const formatDate = (value: string): string => {
  const [year, month, day] = value.split('-');
  return `${year}年${Number(month)}月${Number(day)}日`;
};